var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_c('userComp',{attrs:{"title":"Home Page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }